export const enum eZenBossRouteNames {
  ZenBoss = 'ZenBoss::All Questions',
  MyQuestions = 'ZenBoss::My Questions',
  Notifications = 'ZenBoss::Notifications',
  AskQuestion = 'ZenBoss::Ask a Question',
  ViewQuestion = 'ZenBoss::View Question'
}
